import theme from "assets/styles/themes";
import { TMoreOptions } from "components/Projection/ProjectionBody/chartsListConfig";
import { LD9Chart } from "store/slice/charts";

interface ChartButton<T> {
    group: T;
    button: T;
    rect: T;
    circle: T;
    label: T;
}

const bridgeGreenButtons: ChartButton<Highcharts.SVGElement>[] = [];

export const drawButtons = (chart: Highcharts.Chart, chartDataState: LD9Chart, moreOptions?: TMoreOptions) => {
    if (bridgeGreenButtons.length) {
        bridgeGreenButtons.forEach((el) => {
            Object.values(el).forEach((svgElement: Highcharts.SVGElement) => {
                svgElement?.destroy();
            });
        });
    }

    chartDataState.series.data.slice(1, chartDataState.series.data.length - 1).forEach((el, i) => {
        const role = (el.name as string).replace(/Add|Replace/g, "");
        const renderer = chart.renderer as Highcharts.SVGRenderer;

        bridgeGreenButtons[i] = {
            group: {} as Highcharts.SVGElement,
            button: {} as Highcharts.SVGElement,
            rect: {} as Highcharts.SVGElement,
            circle: {} as Highcharts.SVGElement,
            label: {} as Highcharts.SVGElement,
        };

        // Group
        bridgeGreenButtons[i].group = renderer
            .g(`button-0`)
            .attr({
                zIndex: 4,
            })
            .translate(chart.xAxis[0].toPixels(i + 1, true), chart.chartHeight - 105)
            .add();

        // Green Square
        bridgeGreenButtons[i].rect = renderer
            .rect(0, 0, 70, 70, 6)
            .attr({
                fill: theme.palette.success.light,
            })
            .add(bridgeGreenButtons[i].group);

        // Green Square
        bridgeGreenButtons[i].circle = renderer
            .circle(bridgeGreenButtons[i].rect.getBBox().width / 2, 16, 8.5)
            .attr({
                fill: theme.palette.common.white,
            })
            .add(bridgeGreenButtons[i].group);

        // Cross Sign
        bridgeGreenButtons[i].label = renderer
            .label("+", 0, 0)
            .css({
                color: theme.palette.success.main,
                fontSize: "14px",
                fontWeight: "bold",
                textAlign: "center",
            })
            .add(bridgeGreenButtons[i].group);
        bridgeGreenButtons[i].label.attr({
            x:
                bridgeGreenButtons[i].circle.getBBox().x +
                bridgeGreenButtons[i].circle.getBBox().width / 2 -
                bridgeGreenButtons[i].label.getBBox().width / 2,
            y:
                bridgeGreenButtons[i].circle.getBBox().y +
                bridgeGreenButtons[i].circle.getBBox().height / 2 -
                bridgeGreenButtons[i].label.getBBox().height / 2 -
                1,
        });

        // Role name
        bridgeGreenButtons[i].label = renderer
            .label(role, bridgeGreenButtons[i].rect.getBBox().width / 2, 28)
            .css({
                color: theme.palette.common.white,
                fontSize: "12px",
                whiteSpace: "break-spaces",
                fontWeight: "bold",
                letterSpacing: "1.25px",
            })
            .add(bridgeGreenButtons[i].group);
        bridgeGreenButtons[i].label.attr({
            x: bridgeGreenButtons[i].rect.getBBox().width / 2 - bridgeGreenButtons[i].label.getBBox().width / 2,
        });

        // "Brief" string
        bridgeGreenButtons[i].label = renderer
            .label("Brief", bridgeGreenButtons[i].rect.getBBox().width / 2, 44)
            .css({
                color: theme.palette.common.white,
                fontSize: "12px",
                textAlign: "center",
                letterSpacing: "1.25px",
            })
            .add(bridgeGreenButtons[i].group);
        bridgeGreenButtons[i].label.attr({
            x: bridgeGreenButtons[i].rect.getBBox().width / 2 - bridgeGreenButtons[i].label.getBBox().width / 2,
        });

        // Button (goes on top of the other elements)
        bridgeGreenButtons[i].button = renderer
            .rect(0, 0, 70, 70, 6)
            .attr({
                fill: "transparent",
            })
            .css({
                cursor: "pointer",
            })
            .on("mouseover", () => {
                bridgeGreenButtons[i].rect.attr({
                    fill: theme.palette.success.main,
                });
            })
            .on("mouseout", () => {
                bridgeGreenButtons[i].rect.attr({
                    fill: theme.palette.success.light,
                });
            })
            .on("click", () => {
                if (moreOptions?.createBriefCallback) {
                    moreOptions.createBriefCallback("Brief", `Brief - ${role}`);
                }
            })
            .add(bridgeGreenButtons[i].group);
    });
};
